package com.ai.mitra

import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import com.ai.mitra.presentation.screens.mainscreen.MainScreen
import com.ai.mitra.presentation.screens.mainscreen.MainViewModel

@Composable
fun App(mainViewModel: MainViewModel) {
    MaterialTheme {
        MainScreen(mainViewModel)
    }
}